{
  "actionbar.actions": "Handlinger",
  "actionbar.actionsAvailable": "Tilgængelige handlinger.",
  "actionbar.clearSelection": "Ryd markering",
  "actionbar.selected": "{count, plural, =0 {Ingen valgt} other {# valgt}}",
  "actionbar.selectedAll": "Alle valgt",
  "breadcrumbs.more": "Flere elementer",
  "button.pending": "afventende",
  "calendar.invalidSelection": "Valgte {selectedCount, plural, one {dato} other {datoer}} ikke ledige.",
  "combobox.noResults": "Ingen resultater",
  "contextualhelp.help": "Hjælp",
  "contextualhelp.info": "Oplysninger",
  "datepicker.endTime": "Sluttidspunkt",
  "datepicker.startTime": "Starttidspunkt",
  "datepicker.time": "Klokkeslæt",
  "dialog.alert": "Advarsel",
  "dialog.dismiss": "Luk",
  "dropzone.replaceMessage": "Drop fil for at erstatte",
  "inlinealert.informative": "Oplysninger",
  "inlinealert.negative": "Fejl",
  "inlinealert.notice": "Advarsel",
  "inlinealert.positive": "Fuldført",
  "label.(optional)": "(valgfrit)",
  "label.(required)": "(obligatorisk)",
  "menu.moreActions": "Flere handlinger",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Vælg…",
  "picker.selectedCount": "{count, plural, =0 {Ingen elementer valgt} one {# element valgt} other {# elementer valgt}}",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.cancel": "Annuller",
  "table.editCell": "Rediger celle",
  "table.loading": "Indlæser...",
  "table.loadingMore": "Indlæser flere...",
  "table.resizeColumn": "Tilpas størrelse på kolonne",
  "table.save": "Gem",
  "table.sortAscending": "Sorter stigende",
  "table.sortDescending": "Sorter faldende",
  "tag.actions": "Handlinger",
  "tag.hideButtonLabel": "Vis mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Vis alle ({tagCount, number})",
  "toast.clearAll": "Ryd alle",
  "toast.collapse": "Skjul",
  "toast.showAll": "Vis alle"
}
